// Use a function to dynamically generate the URL
import { WEBSOCKET_URL } from "@/config/constants"
import { createConsumer } from "@rails/actioncable"

export default createConsumer(WEBSOCKET_URL)
